import { Sparkles } from 'lucide-react'
import { useAgentPanelStore } from '../store/agentStore'
import { cn } from '@/lib/utils'

type Props = {
    /** Override className when embedding in topbar/header */
    className?: string
    /** Show the Cmd+I shortcut hint */
    showShortcut?: boolean
}

/**
 * Small button that opens the global AgentPanel. Drop into topbar/header.
 * Mirrors the panel's open state via the same store.
 */
export default function AgentLauncher({ className, showShortcut = true }: Props) {
    const togglePanel = useAgentPanelStore(s => s.togglePanel)
    const isOpen = useAgentPanelStore(s => s.isOpen)

    const isMac = typeof navigator !== 'undefined' && /mac/i.test(navigator.platform)
    const shortcut = isMac ? '⌘I' : 'Ctrl+I'

    return (
        <button
            type='button'
            onClick={togglePanel}
            title={`Open agent (${shortcut})`}
            className={cn(
                'inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-medium text-slate-700 shadow-sm transition-all hover:border-primary-main/30 hover:bg-primary-main/5 hover:text-primary-main',
                isOpen && 'border-primary-main/30 bg-primary-main/5 text-primary-main',
                className
            )}
        >
            <Sparkles className='h-3.5 w-3.5' />
            <span className='hidden sm:inline'>Agent</span>
            {showShortcut && (
                <kbd className='hidden rounded border border-slate-200 bg-slate-50 px-1 text-[10px] font-mono text-slate-400 sm:inline'>
                    {shortcut}
                </kbd>
            )}
        </button>
    )
}
